<template lang="pug">
.receive-packet-container(v-if="visible" )
  .scroll-container
    .coupons-container
      .coupon(v-for="(item,index) in couponList")
        couponsItems(
            :cardInfo="item"
            cardBackground="https://m.hellobike.com/resource/gallery/43/NoBmjz0R_104.png"
            cardWidth="1.03rem"
            cardHeight="1.226rem"
            :index="index"
            cardClass="ladder-blend-choose")
        .choose-button(@click="selectCoupon(item)") 选TA
  .receive-packet-close(@click="closeModal")
      img.close(src="https://m.hellobike.com/resource/helloyun/08345/KyfI3xjHl3.png")
</template>

<script>
import Lottie from '@/components/lottie';
import couponsItems from './coupons-Items.vue';

export default {
  components: {
    Lottie,
    couponsItems,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    couponList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    selectCoupon(coupon) {
      this.$emit('update:visible', false);
      this.$emit('click-btn', coupon);
    },
    closeModal() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="less" scoped>
.receive-packet-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);

  .scroll-container {
    position: relative;
    overflow-x: auto;
    z-index: 223;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }

    .coupons-container {
      z-index: 223;
      width: fit-content;
      position: relative;
      display: flex;
      padding-left: 0.22rem;
      margin: 0 auto;
      overflow-x: auto;

      .coupon {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 0.119rem;

        .choose-button {
          margin-top: 0.23rem;
          text-align: center;
          color: #fff;
          font-family: "PingFang HK", sans-serif;
          font-weight: 600;
          font-size: 0.14rem;
          line-height: 0.26rem;
          width: 0.73rem;
          height: 0.26rem;
          background: #fb990f;
          border-radius: 1.024rem;
        }
      }
    }
  }

  .receive-packet-close {
    margin-top: 0.51rem;
    display: flex;
    justify-content: center;
    z-index: 223;
    position: relative;

    .close {
      width: 0.3rem;
      height: 0.3rem;
      z-index: 101;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
